import { useMutation, useQueryClient } from 'react-query';
import { FriendshipService } from '../services/FriendshipService';
import InfoToast from '../components/InfoToast';
import ErrorToast from '../components/ErrorToast';
import { useTranslation } from 'react-i18next';

export function useFriendRequests() {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const acceptFriendRequestMutation = useMutation(
    (friendshipId: string) => {
      return FriendshipService.acceptFriendRequest(friendshipId);
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['acceptedFriendships']);
        void queryClient.invalidateQueries(['receivedFriendships']);
        void queryClient.invalidateQueries(['exploreFeed']);
        void queryClient.invalidateQueries(['followingFeed']);
        void queryClient.invalidateQueries(['userNotifications']);

        InfoToast('You successfully accepted the friend request.');
      },
      onError: () => {
        ErrorToast(t('Errors.general'));
      },
    },
  );

  const rejectFriendRequestMutation = useMutation(
    (friendshipId: string) => {
      return FriendshipService.rejectFriendRequest(friendshipId);
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['acceptedFriendships']);
        void queryClient.invalidateQueries(['receivedFriendships']);
        void queryClient.invalidateQueries(['userNotifications']);

        InfoToast('You successfully rejected the friend request.');
      },
      onError: () => {
        ErrorToast(t('Errors.general'));
      },
    },
  );

  const acceptFriendRequest = (friendshipId: string) => {
    return acceptFriendRequestMutation.mutate(friendshipId);
  };

  const rejectFriendRequest = (friendshipId: string) => {
    return rejectFriendRequestMutation.mutate(friendshipId);
  };

  return {
    loading:
      acceptFriendRequestMutation?.isLoading ||
      rejectFriendRequestMutation?.isLoading,
    success:
      acceptFriendRequestMutation?.isSuccess ||
      rejectFriendRequestMutation?.isSuccess,
    error:
      acceptFriendRequestMutation?.isError ||
      rejectFriendRequestMutation?.isError,
    acceptFriendRequest,
    rejectFriendRequest,
  };
}
